import { Check, Close, HourglassBottom } from "@mui/icons-material";
import { Dialog, IconButton } from "@mui/material";
import { useState } from "react";

import useService from "../../../../../../hooks/useService";
import ModalButton from "../../../../../global/ModalButton";
import ResponseModal from "../../../../../global/ResponseModal";

export default function ActionItemDelete({
  deleteOpen,
  setDeleteOpen,
  activeActionItem,
  setActiveActionItem,
  onSuccess = () => {},
}) {
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [errorArray, setErrorArray] = useState([]);

  const handleOpenSuccess = () => {
    setOpenSuccess(!openSuccess);
    setDeleteOpen(false);
    onSuccess();
  };

  const actionItemRepository = useService("repositories/actionable-items-repository");

  const handleNewActionDelete = async () => {
    try {
      await actionItemRepository.delete(activeActionItem.id);
      setOpenSuccess(!openSuccess);
    } catch (error) {
      if (error.status) {
        setOpenError(!openError);
        const res = error.status;
        setErrorArray(res);
      }
    }
  };

  const handleModalClose = () => {
    setDeleteOpen(false);
    setActiveActionItem(null);
  };

  return (
    <Dialog open={deleteOpen} fullWidth>
      <div
        style={{
          padding: 20,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            fontSize: "20px",
          }}
        >
          {" "}
          <IconButton onClick={() => handleModalClose()}>
            <Close />
          </IconButton>
        </div>
        <h1
          style={{
            fontSize: 20,
            margin: "0 0 1rem 0",
            textAlign: "center",
            color: "#d32f2f",
            fontWeight: "bold",
          }}
        >
          Delete Action Item
        </h1>

        {!activeActionItem ? (
          ""
        ) : (
          <div>
            <div style={{ margin: "1rem 0" }}>
              <div>
                <span style={{ fontWeight: "bold" }}>Acting User Name: </span>{" "}
                <span>
                  {activeActionItem?.actingUser?.name || activeActionItem?.acting_user?.name || ""}
                </span>
              </div>
              <div>
                <span style={{ fontWeight: "bold" }}>Assigned By: </span>{" "}
                <span>
                  {activeActionItem?.created_by?.name || activeActionItem?.createdBy?.name}
                </span>
              </div>
              <div>
                <span style={{ fontWeight: "bold" }}>Due Date:</span>{" "}
                <span>
                  {new Date(
                    activeActionItem?.due_date || activeActionItem?.dueDate
                  ).toLocaleString()}
                </span>
              </div>
              <div>
                <span style={{ fontWeight: "bold" }}>Detail:</span>{" "}
                <span>{activeActionItem?.action_detail || activeActionItem?.actionDetail}</span>
              </div>
              <div>
                <span style={{ fontWeight: "bold" }}>Status:</span>{" "}
                <span style={{ textTransform: "capitalize" }}>
                  {activeActionItem?.status}{" "}
                  {activeActionItem?.status === "done" ? <Check /> : <HourglassBottom />}
                </span>
              </div>
            </div>
            <ModalButton
              action={handleNewActionDelete}
              baseColor={"#d32f2f"}
              content="Delete Action Item"
              icon={"delete"}
            />
          </div>
        )}
        <ResponseModal
          title="Action Item Removed"
          description="Action Item has been successfully deleted"
          openBool={openSuccess}
          setOpenBool={setOpenSuccess}
          handleCloseFunc={handleOpenSuccess}
        />
        <ResponseModal
          title="Error Removing Action Item"
          isError={true}
          openBool={openError}
          setOpenBool={setOpenError}
          errorMessage={errorArray}
        />
      </div>
    </Dialog>
  );
}
